import {CountryModel} from "../types/country";
import {GeoRegionModel} from "../types/geo-region";
import {RegionModel} from "../types/region";
import {ContactLocaleModel} from "../types/contact-locale";
import {AppSettingsModel} from "./app-settings.model";
import {AuthDetailModel} from "./auth-detail.model";
import {JSONModel, jsonProperty} from "../json.model";
import {ContactCountryModel} from "../types/contact-country";
import {ContactLanguageModel} from "../types/contact-language";

export class AppSettingsResponseModel extends JSONModel {
  @jsonProperty(AppSettingsModel) settings: AppSettingsModel;
  @jsonProperty([CountryModel]) countries: CountryModel[];
  @jsonProperty([GeoRegionModel]) geoRegions: GeoRegionModel[];
  @jsonProperty([RegionModel]) regions: RegionModel[];
  @jsonProperty([ContactLocaleModel]) contactLocales: ContactLocaleModel[];
  @jsonProperty([ContactCountryModel]) contactCountries: ContactCountryModel[];
  @jsonProperty([ContactLanguageModel]) contactLanguages: ContactLanguageModel[];
  @jsonProperty(AuthDetailModel) user: AuthDetailModel;
}
